import { render, staticRenderFns } from "./CoursesForBeginners.vue?vue&type=template&id=57a3ef16&scoped=true&"
import script from "./CoursesForBeginners.vue?vue&type=script&lang=js&"
export * from "./CoursesForBeginners.vue?vue&type=script&lang=js&"
import style0 from "./CoursesForBeginners.vue?vue&type=style&index=0&id=57a3ef16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a3ef16",
  null
  
)

export default component.exports